function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.87,4.4h16l.24.07a4.06,4.06,0,0,1,3.34,3.65c.06,1.53,0,3.06,0,4.59a1.2,1.2,0,0,1-.5,1,1.28,1.28,0,0,1-1.41.18,1.26,1.26,0,0,1-.81-1.21c0-1.31,0-2.63,0-4a1.39,1.39,0,0,0-1.54-1.55c-1.9,0-3.81,0-5.71,0h-.29s0,.06,0,.06a2.79,2.79,0,0,1,2,3V30.43h3.93a1.4,1.4,0,0,0,1.56-1.57V23.75a2.41,2.41,0,0,1,.05-.54,1.35,1.35,0,0,1,1.43-1,1.32,1.32,0,0,1,1.24,1.32c0,1.83,0,3.66,0,5.49a4.1,4.1,0,0,1-4.17,4.14h-4c0,.48,0,.91,0,1.33a2.75,2.75,0,0,1-3.7,2.61L5.65,34.48A2.78,2.78,0,0,1,3.56,31.6V11c0-1.29,0-2.57,0-3.86A2.65,2.65,0,0,1,5.25,4.62,4.57,4.57,0,0,1,5.87,4.4Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M36.45,18.4a8.6,8.6,0,0,1-.76,1c-1.67,1.7-3.35,3.37-5,5.05a1.42,1.42,0,0,1-1.3.47,1.35,1.35,0,0,1-1.13-1.39c0-1.22,0-2.44,0-3.66v-.4H22.86a1.38,1.38,0,0,1-1.45-1.11,1.36,1.36,0,0,1,1.38-1.64h5.43v-.35c0-1.21,0-2.42,0-3.63a1.35,1.35,0,0,1,.85-1.38,1.36,1.36,0,0,1,1.58.36c1.77,1.79,3.56,3.56,5.32,5.35a3.76,3.76,0,0,1,.48.74Z"
});

var SvgLogoutIcon = function SvgLogoutIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoutIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout_icon.61bd1eb6.svg";
export { ForwardRef as ReactComponent };